// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__2Dg_j","inputLabel":"styles_inputLabel__u_wTn","inputLabelText":"styles_inputLabelText__WsyhD","inputField":"styles_inputField__3eqTj"};